export const KPI_GROUPS = {
  CURRENCY: 'currency',
  COUNT: 'count',
  WEIGHT: 'weight',
  LENGTH: 'length',
  AREA: 'area',
  VOLUME: 'volume',
  TIME: 'time',
  ENERGY: 'energy',
  PRESSURE: 'pressure',
  FLOW: 'flow',
  INDEX: 'index',
  DATA_VOLUME: 'data_volume',

  RELATIVE: 'relative',

  OTHER: 'other',
} as const;

export const KPI_UNITS_CODES = {
  // Currency
  EUR: 'EUR',
  USD: 'USD',
  GBP: 'GBP',
  CHF: 'CHF',
  JPY: 'JPY',
  CNY: 'CNY',
  CAD: 'CAD',
  AUD: 'AUD',
  SEK: 'SEK',
  NOK: 'NOK',
  DKK: 'DKK',
  PLN: 'PLN',
  CZK: 'CZK',
  HUF: 'HUF',
  SGD: 'SGD',
  HKD: 'HKD',
  INR: 'INR',
  MXN: 'MXN',
  BRL: 'BRL',
  ZAR: 'ZAR',
  AED: 'AED',
  SAR: 'SAR',
  TRY: 'TRY',

  // Count
  PCS: 'pcs',

  // Weight
  G: 'g',
  KG: 'kg',
  T: 't',
  US_T: 'US-t',
  UK_T: 'UK-t',
  LB: 'lb',
  OZ: 'oz',

  // Length
  MM: 'mm',
  CM: 'cm',
  M: 'm',
  KM: 'km',
  IN: 'in',
  FT: 'ft',
  YD: 'yd',
  MI: 'mi',

  // Area
  M2: 'm²',
  FT2: 'ft²',
  AC: 'ac',
  HA: 'ha',

  // Volume
  M3: 'm³',
  FT3: 'ft³',
  L: 'l',
  GAL_US: 'gal (US)',
  GAL_UK: 'gal (UK)',

  // Time
  MS: 'ms',
  S: 's',
  MIN: 'min',
  H: 'h',
  D: 'd',

  // Energy
  KWH: 'kWh',
  MWH: 'MWh',
  MW: 'MW',

  // Pressure
  BAR: 'bar',
  PSI: 'psi',

  // Flow
  M3_H: 'm³/h',
  L_H: 'l/h',
  GAL_H: 'gal/h',
  FT3_MIN: 'ft³/min',

  // Index
  INDEX_POINT: 'index point',

  // Data Volume
  BIT: 'bit',
  BYTE: 'byte',
  KB: 'kB',
  MB: 'MB',
  GB: 'GB',
  TB: 'TB',
  PB: 'PB',

  // Percent
  PERCENT: '%',
} as const;

export const KPI_UNITS_BY_GROUP = {
  [KPI_GROUPS.CURRENCY]: [
    KPI_UNITS_CODES.EUR,
    KPI_UNITS_CODES.USD,
    KPI_UNITS_CODES.GBP,
    KPI_UNITS_CODES.CHF,
    KPI_UNITS_CODES.JPY,
    KPI_UNITS_CODES.CNY,
    KPI_UNITS_CODES.CAD,
    KPI_UNITS_CODES.AUD,
    KPI_UNITS_CODES.SEK,
    KPI_UNITS_CODES.NOK,
    KPI_UNITS_CODES.DKK,
    KPI_UNITS_CODES.PLN,
    KPI_UNITS_CODES.CZK,
    KPI_UNITS_CODES.HUF,
    KPI_UNITS_CODES.SGD,
    KPI_UNITS_CODES.HKD,
    KPI_UNITS_CODES.BRL,
    KPI_UNITS_CODES.MXN,
    KPI_UNITS_CODES.INR,
    KPI_UNITS_CODES.ZAR,
    KPI_UNITS_CODES.AED,
    KPI_UNITS_CODES.SAR,
    KPI_UNITS_CODES.TRY,
  ],
  [KPI_GROUPS.COUNT]: [KPI_UNITS_CODES.PCS],
  [KPI_GROUPS.WEIGHT]: [
    KPI_UNITS_CODES.G,
    KPI_UNITS_CODES.KG,
    KPI_UNITS_CODES.T,
    KPI_UNITS_CODES.US_T,
    KPI_UNITS_CODES.UK_T,
    KPI_UNITS_CODES.LB,
    KPI_UNITS_CODES.OZ,
  ],
  [KPI_GROUPS.LENGTH]: [
    KPI_UNITS_CODES.MM,
    KPI_UNITS_CODES.CM,
    KPI_UNITS_CODES.M,
    KPI_UNITS_CODES.KM,
    KPI_UNITS_CODES.IN,
    KPI_UNITS_CODES.FT,
    KPI_UNITS_CODES.YD,
    KPI_UNITS_CODES.MI,
  ],
  [KPI_GROUPS.AREA]: [
    KPI_UNITS_CODES.M2,
    KPI_UNITS_CODES.FT2,
    KPI_UNITS_CODES.AC,
    KPI_UNITS_CODES.HA,
  ],
  [KPI_GROUPS.VOLUME]: [
    KPI_UNITS_CODES.M3,
    KPI_UNITS_CODES.FT3,
    KPI_UNITS_CODES.L,
    KPI_UNITS_CODES.GAL_US,
    KPI_UNITS_CODES.GAL_UK,
  ],
  [KPI_GROUPS.TIME]: [
    KPI_UNITS_CODES.MS,
    KPI_UNITS_CODES.S,
    KPI_UNITS_CODES.MIN,
    KPI_UNITS_CODES.H,
    KPI_UNITS_CODES.D,
  ],
  [KPI_GROUPS.ENERGY]: [
    KPI_UNITS_CODES.KWH,
    KPI_UNITS_CODES.MWH,
    KPI_UNITS_CODES.MW,
  ],
  [KPI_GROUPS.PRESSURE]: [KPI_UNITS_CODES.BAR, KPI_UNITS_CODES.PSI],
  [KPI_GROUPS.FLOW]: [
    KPI_UNITS_CODES.M3_H,
    KPI_UNITS_CODES.L_H,
    KPI_UNITS_CODES.GAL_H,
    KPI_UNITS_CODES.FT3_MIN,
  ],
  [KPI_GROUPS.INDEX]: [KPI_UNITS_CODES.INDEX_POINT],
  [KPI_GROUPS.DATA_VOLUME]: [
    KPI_UNITS_CODES.BIT,
    KPI_UNITS_CODES.BYTE,
    KPI_UNITS_CODES.KB,
    KPI_UNITS_CODES.MB,
    KPI_UNITS_CODES.GB,
    KPI_UNITS_CODES.TB,
    KPI_UNITS_CODES.PB,
  ],
  [KPI_GROUPS.RELATIVE]: [KPI_UNITS_CODES.PERCENT],
  [KPI_GROUPS.OTHER]: [],
};

type KpiGroup = (typeof KPI_GROUPS)[keyof typeof KPI_GROUPS];

type KpiUnitCode<G extends KpiGroup> = (typeof KPI_UNITS_BY_GROUP)[G][number];

export class KpiUnit {
  public readonly group: KpiGroup;
  public readonly code: KpiUnitCode<KpiGroup> | string;

  constructor(group: KpiGroup, code: KpiUnitCode<KpiGroup> | string) {
    this.group = group;
    this.code = code;
  }

  public toString(): string {
    return `${this.group}:${this.code}`;
  }

  static fromString(id: string): KpiUnit {
    const unit = KpiUnit.fromStringOrNull(id);
    if (!unit) {
      // Unit code without group prefix (e.g. "EUR" instead of "currency:EUR")
      // Search through all groups to find the correct one
      for (const [group, codes] of Object.entries(KPI_UNITS_BY_GROUP)) {
        if ((codes as readonly string[]).includes(id)) {
          return new KpiUnit(group as KpiGroup, id);
        }
      }
      return new KpiUnit(KPI_GROUPS.OTHER, id);
    }
    return unit;
  }

  static fromStringOrNull(id: string): KpiUnit | null {
    const [group, code] = id.split(':');

    if (!group || !code) {
      return null;
    }
    return new KpiUnit(group as KpiGroup, code);
  }
}

type KpiMap = {
  [G in KpiGroup]: {
    [U in KpiUnitCode<G>]: KpiUnit;
  };
};

export const KPI_UNITS = Object.fromEntries(
  Object.entries(KPI_UNITS_BY_GROUP).map(([group, units]) => [
    group,
    Object.fromEntries(
      units.map((unit) => [
        unit,
        new KpiUnit(group as KpiGroup, unit as KpiUnitCode<KpiGroup>),
      ]),
    ),
  ]),
) as KpiMap;
